module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-container"
  }, [_c('el-card', {
    staticClass: "tableInfo"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("基础信息")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-row', {
    staticClass: "rowItem"
  }, [_c('el-col', {
    staticClass: "lable",
    attrs: {
      "span": 8
    }
  }, [_vm._v("商户名称：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_vm._v("\n                " + _vm._s(this.venueInfo.venueName) + "\n            ")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "rowItem"
  }, [_c('el-col', {
    staticClass: "lable",
    attrs: {
      "span": 8
    }
  }, [_vm._v("会员端平台名称：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_vm._v("\n                " + _vm._s(this.venueInfo.chineseName) + "\n            ")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "rowItem"
  }, [_c('el-col', {
    staticClass: "lable",
    attrs: {
      "span": 8
    }
  }, [_vm._v("会员端平台简称：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_vm._v("\n                " + _vm._s(this.venueInfo.englishName) + "\n            ")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "rowItem"
  }, [_c('el-col', {
    staticClass: "lable",
    attrs: {
      "span": 8
    }
  }, [_vm._v("商户logo：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('img', {
    attrs: {
      "src": 'http://zlesp.zlydgy.cn:8091/images/' + this.venueInfo.logo,
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "rowItem"
  }, [_c('el-row', {
    staticClass: "lable",
    attrs: {
      "span": 3
    }
  }, [_vm._v("商户介绍（首页展示）：")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "height": "250px",
      "overflow-y": "auto"
    },
    attrs: {
      "span": 20
    },
    domProps: {
      "innerHTML": _vm._s(this.venueInfo.info)
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addType == 1),
      expression: "addType==1"
    }],
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.venueInfo)
      }
    }
  }, [_vm._v("\n                编辑\n              ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addType == 2),
      expression: "addType==2"
    }],
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addBtn()
      }
    }
  }, [_vm._v("\n                新增\n              ")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14,
      "offset": 2
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("启动页")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("会员端登录页")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("员工端登录页")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "yulan",
    attrs: {
      "span": 8
    }
  }, [_c('img', {
    staticClass: "imgLogoyulan",
    attrs: {
      "src": 'http://zlesp.zlydgy.cn:8091/images/' + this.imgList.startimage,
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "yulan",
    attrs: {
      "span": 8,
      "offset": 2
    }
  }, [_c('img', {
    staticClass: "imgLogoyulan",
    attrs: {
      "src": 'http://zlesp.zlydgy.cn:8091/images/' + this.imgList.memberloginimage,
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "yulan",
    attrs: {
      "span": 8,
      "offset": 2
    }
  }, [_c('img', {
    staticClass: "imgLogoyulan",
    attrs: {
      "src": 'http://zlesp.zlydgy.cn:8091/images/' + this.imgList.employeeloginimage,
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10,
      "offset": 2
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.edit2()
      }
    }
  }, [_vm._v("\n                编辑\n              ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "设置",
      "visible": _vm.dialogVisible,
      "width": "1000px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "venueInfo",
    attrs: {
      "model": _vm.venueInfo,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [(_vm.type == 1) ? _c('el-form-item', {
    attrs: {
      "label": "商户名称",
      "prop": "venueName"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入商户名称"
    },
    model: {
      value: (_vm.venueInfo.venueName),
      callback: function($$v) {
        _vm.$set(_vm.venueInfo, "venueName", $$v)
      },
      expression: "venueInfo.venueName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.type == 1) ? _c('el-form-item', {
    attrs: {
      "label": "会员端平台名称"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入会员端平台名称"
    },
    model: {
      value: (_vm.venueInfo.chineseName),
      callback: function($$v) {
        _vm.$set(_vm.venueInfo, "chineseName", $$v)
      },
      expression: "venueInfo.chineseName"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.type == 1) ? _c('el-form-item', {
    attrs: {
      "label": "会员端平台简称"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入会员端平台简称"
    },
    model: {
      value: (_vm.venueInfo.englishName),
      callback: function($$v) {
        _vm.$set(_vm.venueInfo, "englishName", $$v)
      },
      expression: "venueInfo.englishName"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.type == 1) ? _c('el-form-item', {
    attrs: {
      "label": "商户简介",
      "prop": "info"
    }
  }, [_c('editor-bar', {
    attrs: {
      "isClear": _vm.isClear
    },
    model: {
      value: (_vm.venueInfo.info),
      callback: function($$v) {
        _vm.$set(_vm.venueInfo, "info", $$v)
      },
      expression: "venueInfo.info"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type == 1) ? _c('el-form-item', {
    ref: "uploadElement",
    attrs: {
      "label": "商户logo"
    }
  }, [_c('el-upload', {
    ref: "upload4",
    class: {
      uploaderNone: _vm.hideUpload4
    },
    attrs: {
      "action": "aa",
      "list-type": "picture-card",
      "auto-upload": false,
      "http-request": _vm.uploadFile4,
      "file-list": _vm.fileList4,
      "multiple": "",
      "limit": 1,
      "on-change": _vm.onChange4,
      "on-remove": _vm.handleRemove4,
      "accept": "image/png,image/gif,image/jpg,image/jpeg"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.type == 2) ? _c('el-form-item', {
    ref: "uploadElement",
    attrs: {
      "label": "启动背景图"
    }
  }, [_c('el-upload', {
    ref: "upload",
    class: {
      uploaderNone: _vm.hideUpload
    },
    attrs: {
      "action": "aa",
      "list-type": "picture-card",
      "auto-upload": false,
      "http-request": _vm.uploadFile,
      "file-list": _vm.fileList,
      "multiple": "",
      "limit": 1,
      "on-change": _vm.onChange,
      "on-remove": _vm.handleRemove,
      "accept": "image/png,image/gif,image/jpg,image/jpeg"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.type == 2) ? _c('el-form-item', {
    ref: "uploadElement",
    attrs: {
      "label": "会员登录背景图"
    }
  }, [_c('el-upload', {
    ref: "upload2",
    class: {
      uploaderNone: _vm.hideUpload2
    },
    attrs: {
      "action": "aa",
      "list-type": "picture-card",
      "auto-upload": false,
      "http-request": _vm.uploadFile2,
      "file-list": _vm.fileList2,
      "multiple": "",
      "limit": 1,
      "on-change": _vm.onChange2,
      "on-remove": _vm.handleRemove2,
      "accept": "image/png,image/gif,image/jpg,image/jpeg"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.type == 2) ? _c('el-form-item', {
    ref: "uploadElement",
    attrs: {
      "label": "员工登录背景图"
    }
  }, [_c('el-upload', {
    ref: "upload3",
    class: {
      uploaderNone: _vm.hideUpload3
    },
    attrs: {
      "action": "aa",
      "list-type": "picture-card",
      "auto-upload": false,
      "http-request": _vm.uploadFile3,
      "file-list": _vm.fileList3,
      "multiple": "",
      "limit": 1,
      "on-change": _vm.onChange3,
      "on-remove": _vm.handleRemove3,
      "accept": "image/png,image/gif,image/jpg,image/jpeg"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm()
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('venueInfo')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-908bc22e"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/configurable/venue.vue
// module id = 622
// module chunks = 70